import { render, staticRenderFns } from "./SettingExpress.vue?vue&type=template&id=31279f98&scoped=true"
import script from "./SettingExpress.vue?vue&type=script&lang=js"
export * from "./SettingExpress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31279f98",
  null
  
)

export default component.exports